export interface SubmitResult {
  ok: boolean;
  message: string;
}

/**
 * 统一处理内置 Form 的提交：读取真实 DOM 数据、校验反垃圾字段、
 * 解析返回体并给出可渲染的提示信息。
 */
export async function submitReaddyForm(
  url: string,
  form: HTMLFormElement,
  honeypotName: string,
  successMessage: string
): Promise<SubmitResult> {
  const formData = new FormData(form);

  const honeypotValue = String(formData.get(honeypotName) ?? "").trim();
  if (honeypotValue) {
    // 命中反垃圾字段时，对外表现与正常提交一致
    return { ok: true, message: successMessage };
  }
  formData.delete(honeypotName);

  const body = new URLSearchParams();
  formData.forEach((value, key) => {
    if (typeof value === "string") {
      body.append(key, value);
    }
  });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });

    const responseText = await response.text();
    let parsed: Record<string, unknown> | null = null;
    try {
      parsed = JSON.parse(responseText) as Record<string, unknown>;
    } catch {
      parsed = null;
    }

    const meta = parsed?.meta as Record<string, unknown> | undefined;
    const rawMessage = meta?.message ?? parsed?.message ?? meta?.detail ?? responseText;
    const serverMsg = typeof rawMessage === "string" ? rawMessage : "";
    const code = typeof parsed?.code === "string" ? (parsed.code as string) : "";
    const isSpam = serverMsg.toLowerCase().includes("spam");

    if (response.ok && !isSpam && (code === "OK" || code === "")) {
      return { ok: true, message: successMessage };
    }
    return {
      ok: false,
      message: serverMsg && !isSpam ? serverMsg : "提交未成功，请检查填写内容后重试。",
    };
  } catch {
    return { ok: false, message: "网络异常，提交失败，请稍后重试。" };
  }
}